var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('a',{staticClass:"header__logo",attrs:{"href":_vm.chounEnvDomain}},[_c('img',{attrs:{"src":"/static/img/choundiary/logo.png","alt":""}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1911b823","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/ChounDiary/partials/HeaderChoun.vue
// module id = null
// module chunks = 